import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "dataType", "level", "lineClamp"];
import PropTypes from 'prop-types';
import React, { forwardRef, useContext } from 'react';
import { PropertyCardContext } from '../PropertyCard/PropertyCard.context';
import { StyledPropertyCardDataArea } from './PropertyCardDataArea.styles';

/**
 * Used for displaying property data in a `PropertyCard`. Provides text styles and the option
 * to truncate text.
 *
 * @extends Paragraph
 * @since 8.63.0
 */
export var PropertyCardDataArea = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    dataType = _ref.dataType,
    level = _ref.level,
    lineClamp = _ref.lineClamp,
    rest = _objectWithoutProperties(_ref, _excluded);
  var context = useContext(PropertyCardContext);
  return /*#__PURE__*/React.createElement(StyledPropertyCardDataArea, _extends({
    as: "div" /* Some tags (ex: <address>) can't be nested inside of a <p> so use <div> instead */,
    ref: forwardedRef,
    appearance: context.appearance,
    dataType: dataType,
    lineClamp: lineClamp
  }, rest), children);
});
PropertyCardDataArea.displayName = 'PropertyCard.DataArea';
PropertyCardDataArea.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Determines the text style.
   */
  dataType: PropTypes.oneOf(['title', 'body1', 'body2', 'body3', 'additionalInfo']),
  /**
   * Truncates text at the number of lines specified (with ellipses). Useful for helping a
   * Property Card maintain a fixed height.
   *
   * For no truncation, use `none`. (Jan 2022 note: `none` is not accepted in
   * Chrome/Saf/Edge even though the
   * [spec](https://www.w3.org/TR/css-overflow-3/#webkit-line-clamp) dictates that `none`
   * should be the initial value. So for now, we map `none` to `initial`.)
   */
  lineClamp: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
PropertyCardDataArea.defaultProps = {
  dataType: 'title',
  lineClamp: 1
};